// Global site-settings hook backed by /api/site/settings.
// Returns { settings, refresh, save } and broadcasts updates across mounted hooks.
import { useEffect, useState } from "react";
import { api } from "./api";

const STORAGE_KEY = "beyx-site-settings-cache";
let _cache = null;
const listeners = new Set();

function readCache() {
  if (_cache) return _cache;
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      _cache = JSON.parse(raw);
      return _cache;
    }
  } catch (e) { /* noop */ }
  return null;
}

function writeCache(next) {
  _cache = next;
  if (typeof window !== "undefined") {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); }
    catch (e) { /* noop */ }
  }
  listeners.forEach((fn) => {
    try { fn(next); } catch (e) { /* noop */ }
  });
}

export function useSiteSettings() {
  const [settings, setSettings] = useState(readCache());

  useEffect(() => {
    const listener = (next) => setSettings(next);
    listeners.add(listener);
    api.get("/site/settings").then((r) => writeCache(r.data)).catch(() => {});
    return () => { listeners.delete(listener); };
  }, []);

  const save = async (patch) => {
    const r = await api.put("/admin/site/settings", patch);
    writeCache(r.data);
    return r.data;
  };

  const refresh = async () => {
    const r = await api.get("/site/settings");
    writeCache(r.data);
    return r.data;
  };

  return { settings, save, refresh };
}
